import { withTheme } from '@rneui/themed';
import React from 'react';
import { Platform, StyleSheet } from 'react-native';
import { FileType } from '@annunciate/core';
import { DownloadButton } from '@annunciate/ui/dist/components/content/DownloadButton';
import { ShareItemButton } from '@annunciate/ui/dist/components/shared/ShareItemButton';
import { Row, View } from '../elements';
import { PlayButton, EllipsisButton } from '../player';
import { FavoriteButton } from './FavoriteButton';
import { ProgressButton } from './ProgressButton';
export const UnthemedContentButtons = ({ item, iconSize, }) => {
    const isVideo = item.asset?.type === FileType.VIDEO;
    const isWeb = Platform.OS === 'web' ? true : false;
    const isDownloadAvailable = !isWeb && !isVideo;
    return (React.createElement(Row, { style: styles.fullBar },
        React.createElement(DownloadButton, { item: item, size: iconSize, isLeftAligned: true }),
        React.createElement(ProgressButton, { item: item, size: iconSize, isLeftAligned: !isDownloadAvailable }),
        React.createElement(FavoriteButton, { item: item, size: iconSize }),
        React.createElement(ShareItemButton, { item: item, size: iconSize }),
        React.createElement(EllipsisButton, { item: item, size: iconSize }),
        React.createElement(View, { style: { flexGrow: 1 } }),
        React.createElement(PlayButton, { content: item, isRightAligned: true })));
};
export const ContentButtons = withTheme(UnthemedContentButtons, 'ContentButtons');
const styles = StyleSheet.create({
    fullBar: {
        backgroundColor: 'transparent',
        width: '100%',
        justifyContent: 'flex-start',
    },
});
//# sourceMappingURL=ContentButtons.js.map